var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.001 464.001",
    style: {
      enableBackground: "new 0 0 464.001 464.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#734A3E"
    },
    d: "M104.001,176c0,0-16-65.474-16-88c0-48.333,40-48,40-48l0.007-0.007 C151.835,0.167,240.001,0,240.001,0l8,16c44-14,104-16,104-16s11.5,16,16,40c9.325,49.735-8,136-8,136H104.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M240.001,0c0,0-88.5,0-111.993,39.993L128.001,40c0,0-40-0.333-40,48c0,22.526,16,88,16,88h51.636 l52.364-72c0,0,80.667-41.334,144-104c0,0-60,2-104,16L240.001,0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6B47B"
    },
    d: "M391.864,422.878l-0.726-6.536c-0.287-2.585-2.616-4.449-5.201-4.162l-0.407,0.045l-7.027-56.214 c-1.529-12.228-9.943-22.492-21.633-26.389l-46.011-15.337l1.143-2.285l-17.344-11.563c-3.676-2.451-8.643-1.458-11.094,2.219 l-2.444,3.666c-0.72-1.829-1.118-3.806-1.118-5.854v-25.802l34.461-14.358c17.887-7.453,29.538-24.93,29.538-44.308v-8 c13.255,0,24-10.745,24-24c0-6.325-2.451-12.075-6.45-16.362c4.032-22.84,14.019-87.271,6.45-127.638c-4.5-24-16-40-16-40 s-60,2-104,16l-8-16c0,0-88.5,0-111.993,39.993l0,0L128.001,40c0,0-0.01,0-0.029,0c-0.038,0-0.115,0-0.226,0.003 s-0.259,0.007-0.439,0.014c-0.18,0.008-0.393,0.019-0.637,0.035c-0.122,0.008-0.251,0.017-0.388,0.028 c-0.41,0.032-0.886,0.077-1.42,0.139c-0.356,0.042-0.737,0.091-1.142,0.15c-0.405,0.059-0.833,0.127-1.281,0.206 c-0.449,0.08-0.918,0.169-1.406,0.272c-9.753,2.05-26.831,9.054-31.702,32.976c-0.122,0.598-0.236,1.207-0.342,1.826 c-0.319,1.858-0.566,3.813-0.733,5.87S88.001,85.734,88.001,88c0,1.76,0.098,3.782,0.278,6.014s0.443,4.675,0.772,7.277 c0.066,0.521,0.135,1.047,0.206,1.58c1.566,11.717,4.372,26.308,7.119,39.367c0.125,0.594,0.25,1.184,0.374,1.771 c1.868,8.803,3.68,16.801,5.026,22.598c0.113,0.487,0.222,0.953,0.328,1.409c-3.793,4.243-6.103,9.843-6.103,15.984 c0,13.255,10.745,24,24,24v8c0,19.377,11.651,36.854,29.538,44.308l34.462,14.36v25.801c0,2.049-0.398,4.026-1.118,5.854 l-2.444-3.666c-2.451-3.676-7.418-4.67-11.094-2.219l-17.344,11.563l1.143,2.285l-46.011,15.337 c-11.691,3.897-20.105,14.161-21.633,26.389l-7.027,56.214l-0.407-0.045c-2.586-0.287-4.914,1.576-5.202,4.162l-0.726,6.536 c-0.287,2.585,1.576,4.914,4.161,5.201l11.702,1.3v18.621c0,8.836,7.163,16,16,16h40h176h40c8.837,0,16-7.164,16-16V429.38 l11.702-1.3C390.288,427.792,392.152,425.463,391.864,422.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F4F"
    },
    d: "M378.503,356.012c-1.529-12.228-9.943-22.492-21.633-26.389l-51.75-17.25 c-7.535,16.992-49.119,31.628-49.119,31.628l-16,16c0,0.063-14.75,0-16,0l-16-16c0,0-41.584-14.635-49.119-31.628l-51.75,17.25 c-11.691,3.897-20.105,14.161-21.633,26.389l-7.609,60.872l66.11,7.117v40h176v-40h67L378.503,356.012z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#734A3E"
    },
    d: "M104.001,176c0,0-16-65.474-16-88c0-48.333,40-48,40-48l0.007-0.007 C151.168,0.667,240.001,0,240.001,0l8,16c44-14,104-16,104-16s11.5,16,16,40c9.325,49.735-8,136-8,136H104.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M240.001,0c0,0-88.5,0-111.993,39.993L128.001,40c0,0-40-0.333-40,48c0,22.526,16,88,16,88h51.636 l52.364-72c0,0,80.667-41.334,144-104c0,0-60,2-104,16L240.001,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A071"
    },
    d: "M280.001,274.001h-96v26.468c0,5.759-3.186,10.831-8.017,13.659 C243.078,325.871,280.001,274.001,280.001,274.001z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC88E"
    },
    d: "M344.001,160v-16c0-22.091-17.909-40-40-40h-144c-22.091,0-40,17.909-40,40v16 c-13.255,0-24,10.745-24,24s10.745,24,24,24v8c0,19.377,11.651,36.854,29.538,44.308l51.691,21.538 C210.98,285.909,221.438,288,232,288l0,0c10.562,0,21.019-2.092,30.769-6.154l51.694-21.539 c17.887-7.452,29.538-24.929,29.538-44.307v-8c13.255,0,24-10.745,24-24S357.256,160,344.001,160z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M176.001,192L176.001,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8 C184.001,188.4,180.401,192,176.001,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M288.001,192L288.001,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8 C296.001,188.4,292.401,192,288.001,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A071"
    },
    d: "M232.001,248.219c-14.223,0-27.527-3.5-36.5-9.605c-3.652-2.484-4.602-7.461-2.113-11.113 c2.48-3.648,7.461-4.598,11.113-2.113c6.289,4.277,16.57,6.832,27.5,6.832s21.211-2.555,27.5-6.832 c3.66-2.492,8.629-1.539,11.113,2.113c2.488,3.652,1.539,8.629-2.113,11.113C259.529,244.719,246.224,248.219,232.001,248.219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F23F44"
    },
    d: "M144.001,430.04v-18.106c0-7.697-2.774-15.135-7.813-20.953l-44.019-50.813 c-3.552,4.497-5.93,9.93-6.669,15.843l-8.356,66.847C89.868,423.622,123.712,427.587,144.001,430.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6343A"
    },
    d: "M144.001,419.507l-65.936-7.326c-2.586-0.287-4.914,1.576-5.202,4.161l-0.726,6.536 c-0.287,2.585,1.576,4.914,4.161,5.201l67.703,7.523V419.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F23F44"
    },
    d: "M320.001,430.04v-18.106c0-7.697,2.774-15.135,7.813-20.953l44.019-50.813 c3.552,4.497,5.93,9.93,6.669,15.843l8.356,66.847C374.135,423.622,340.29,427.587,320.001,430.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6343A"
    },
    d: "M320.001,419.507l65.936-7.326c2.586-0.287,4.914,1.576,5.202,4.161l0.726,6.536 c0.287,2.585-1.576,4.914-4.161,5.201l-67.703,7.523V419.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F23F44"
    },
    d: "M180.439,302.657L208.001,344l-24,32l-32-64l17.344-11.562 C173.021,297.987,177.988,298.98,180.439,302.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F23F44"
    },
    d: "M283.564,302.657L256.001,344l24,32l32-64l-17.344-11.562 C290.981,297.987,286.015,298.98,283.564,302.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F23F44"
    },
    d: "M232.001,424L232.001,424c-4.418,0-8-3.582-8-8v-56h16v56C240.001,420.419,236.42,424,232.001,424z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6B47B"
    },
    d: "M161.997,243.723c-6.482-6.95-9.995-16.121-9.995-25.625v-91.792 c28.107-3.121,89.334-10.557,152-22.307H160.001c-2.754,0-5.421,0.321-8,0.881v-0.075c-18.257,3.707-32,19.843-32,39.194v16 c-13.255,0-24,10.745-24,24s10.745,24,24,24v8c0,19.378,11.651,36.855,29.538,44.308l51.69,21.538 c2.53,1.054,5.112,1.962,7.727,2.749C186.112,267.883,170.906,253.274,161.997,243.723z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6317f65848fde25385a46edf99a32d10.svg";
export { ForwardRef as ReactComponent };